module.exports = __webpack_public_path__ + "static/brand11-bcda3ee46622cbff0aa00026f509bff1.png";